// extracted by mini-css-extract-plugin
module.exports =  {"switch":"_35875ce240--switch--Iu4Bo","indicator":"_35875ce240--indicator--JD6wH","disabled":"_35875ce240--disabled--WS_Zh"};